/**
 * Онбординг і режим меню (ч.1072 → ч.1080 → ч.1401 → ч.1405, рішення власника).
 *
 * Три режими облікового запису (useAccountMode): «ЕДО» — лише меню електронних документів;
 * «Користувач» — відкрито чужий акаунт: поки в ньому НЕМАЄ доступних організацій, меню і фільтри
 * шапки не показуємо (онбординг — лише підказка); «Бізнес» — повне меню.
 *
 * Джерела — спільні кеші ['mode-context'] і ['orgs']. Поки вантажаться — НЕ онбординг і НЕ «ЕДО»
 * (меню не має блимати).
 */
import { useQuery } from '@tanstack/react-query';
import type { AccountMode, ModeContext } from '@/api/auth';
import { orgs } from '@/api/catalogs';
import { useEffectiveMode, useModeContext } from '@/hooks/useAccountMode';

export function useOnboarding(): {
  onboarding: boolean; edoOnly: boolean; userMode: boolean; mode: AccountMode | null; ctx: ModeContext | null;
} {
  const ctxQ = useModeContext();
  const mode = useEffectiveMode();
  const orgsQ = useQuery({ queryKey: ['orgs'], queryFn: () => orgs.list({ limit: 200 }) });
  const noOrgs = orgsQ.isSuccess
    && (orgsQ.data?.items?.length ?? 0) === 0
    && (orgsQ.data?.total ?? 0) === 0;
  return {
    onboarding: mode === 'USER' && noOrgs,
    edoOnly: mode === 'EDO',
    userMode: mode === 'USER',
    mode,
    ctx: ctxQ.data ?? null,
  };
}
